import { createApi } from "@reduxjs/toolkit/query/react";
import CustomFetchBase from "../CustomFetchBase";

export const DashboardApi = createApi({
  reducerPath: "DashboardApi",
  baseQuery: CustomFetchBase,
  tagTypes: ["DASHBOARDAPI"],
  endpoints: (build) => ({
    // Get complete dashboard data - matches your single /dashboard route
    getDashboardData: build.query({
      query: ({ refresh = false } = {}) => ({
        url: `/dashboard${refresh ? "?refresh=true" : ""}`,
        method: "GET",
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      }),
      providesTags: ["DASHBOARDAPI"],
    }),

    // Optional: Manual refresh mutation to invalidate cache
    refreshDashboard: build.mutation({
      query: () => ({
        url: `/dashboard`,
        method: "GET",
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      }),
      invalidatesTags: ["DASHBOARDAPI"],
    }),
  }),
});

export const {
  useGetDashboardDataQuery,
  useRefreshDashboardMutation,
  useLazyGetDashboardDataQuery,
} = DashboardApi;
